import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { colorThemeGenerator } from '@spotify-internal/creator-tape';
import { color, kleinBlue } from '@spotify-internal/tokens';
import { Route } from 'react-router-dom';
import { use1PBrandAlignment } from '../../../1PBrandAlignment';

type Props = {
  darkThemePaths: string[];
  children?: JSX.Element;
};

export function PageThemeProvider({ darkThemePaths, children }: Props) {
  const lightTheme = use1PBrandAlignment()
    ? colorThemeGenerator({ primaryColor: kleinBlue })
    : {};

  const darkComponents = {
    app: 'dark',
    table: 'dark',
    tableRow: 'dark',
    buttonIcon: 'dark',
    loadingIndicator: 'dark',
    navBar: 'dark',
    navBarList: 'dark',
    navBarListItem: 'dark',
    // Concerts
    dialogConfirmation: 'dark',
    formGroup: 'dark',
    formInput: 'dark',
    button: 'dark',
  };

  /**
    '#7F80FA' is a lighter / accessible version of Klein Blue meant for dark backgrounds.
    Follow along at https://ghe.spotify.net/encore/foundation/issues/29 for discussions on accessible dark themed color tokens.
  */

  const Wrapper = styled.div`
    --primaryColor: ${props =>
      (props.theme && props.theme.colors && props.theme.colors.primaryColor) ||
      color.spotifyGreen};
  `;

  const darkTheme = use1PBrandAlignment()
    ? {
        ...darkComponents,
        ...colorThemeGenerator({ primaryColor: '#7F80FA' }),
      }
    : darkComponents;

  return (
    <Route path={darkThemePaths}>
      {({ match }) => (
        <ThemeProvider theme={match ? darkTheme : lightTheme}>
          <Wrapper>{children}</Wrapper>
        </ThemeProvider>
      )}
    </Route>
  );
}
